import { render, staticRenderFns } from "./purchaseInformation.vue?vue&type=template&id=2ae43e7e&scoped=true"
import script from "./purchaseInformation.vue?vue&type=script&lang=js"
export * from "./purchaseInformation.vue?vue&type=script&lang=js"
import style0 from "./purchaseInformation.vue?vue&type=style&index=0&id=2ae43e7e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae43e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae43e7e')) {
      api.createRecord('2ae43e7e', component.options)
    } else {
      api.reload('2ae43e7e', component.options)
    }
    module.hot.accept("./purchaseInformation.vue?vue&type=template&id=2ae43e7e&scoped=true", function () {
      api.rerender('2ae43e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/purchaseInformation.vue"
export default component.exports